import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "postal-section" }
const _hoisted_2 = { class: "result-title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "postal-grid" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createTextVNode("Postal Entries ")),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          class: "dropdown",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompetitionId) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPostalEntryData(_ctx.selectedCompetitionId)))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", {
            disabled: "",
            value: null
          }, "Select a Competition", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeCompetitions, (competition) => {
            return (_openBlock(), _createElementBlock("option", {
              key: competition.competitionId,
              value: competition.competitionId
            }, _toDisplayString(competition.competitionTitle), 9, _hoisted_4))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedCompetitionId]
        ]),
        _createElementVNode("button", {
          disabled: _ctx.isSubmitting,
          class: "postal-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addPostalEntry && _ctx.addPostalEntry(...args)))
        }, [
          (!_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Add Postal Entry"))
            : _createCommentVNode("", true),
          (_ctx.isSubmitting)
            ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { for: "id" }, [
        _createElementVNode("strong", null, "Id:")
      ], -1)),
      _createElementVNode("input", {
        id: "id",
        name: "id",
        disabled: "",
        value: _ctx.postalEntryData.competitionId,
        readonly: ""
      }, null, 8, _hoisted_8),
      _cache[6] || (_cache[6] = _createElementVNode("label", { for: "competition" }, [
        _createElementVNode("strong", null, "Competition")
      ], -1)),
      _createElementVNode("input", {
        id: "competition",
        name: "competition",
        disabled: "",
        value: _ctx.postalEntryData.competitionName,
        readonly: ""
      }, null, 8, _hoisted_9),
      _cache[7] || (_cache[7] = _createElementVNode("label", { for: "limit" }, [
        _createElementVNode("strong", null, "Ticket Limit:")
      ], -1)),
      _createElementVNode("input", {
        id: "limit",
        name: "limit",
        disabled: "",
        value: _ctx.postalEntryData.ticketLimit,
        readonly: ""
      }, null, 8, _hoisted_10),
      _cache[8] || (_cache[8] = _createElementVNode("label", { for: "sold" }, [
        _createElementVNode("strong", null, "Tickets Sold:")
      ], -1)),
      _createElementVNode("input", {
        id: "sold",
        name: "sold",
        disabled: "",
        value: _ctx.postalEntryData.ticketsSold,
        readonly: ""
      }, null, 8, _hoisted_11),
      _cache[9] || (_cache[9] = _createElementVNode("label", { for: "available" }, [
        _createElementVNode("strong", null, "Tickets Available:")
      ], -1)),
      _createElementVNode("input", {
        id: "available",
        name: "available",
        disabled: "",
        value: _ctx.postalEntryData.ticketsAvailable,
        readonly: ""
      }, null, 8, _hoisted_12),
      _cache[10] || (_cache[10] = _createElementVNode("label", { for: "startDate" }, [
        _createElementVNode("strong", null, "Start Date:")
      ], -1)),
      _createElementVNode("input", {
        id: "startDate",
        name: "startDate",
        disabled: "",
        value: _ctx.postalEntryData.startDate,
        readonly: ""
      }, null, 8, _hoisted_13),
      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "endDate" }, [
        _createElementVNode("strong", null, "End Date:")
      ], -1)),
      _createElementVNode("input", {
        id: "endDate",
        name: "startDate",
        disabled: "",
        value: _ctx.postalEntryData.endDate,
        readonly: ""
      }, null, 8, _hoisted_14),
      _cache[12] || (_cache[12] = _createElementVNode("label", { for: "userTicketCap" }, [
        _createElementVNode("strong", null, "User Ticket Cap:")
      ], -1)),
      _createElementVNode("input", {
        id: "userTicketCap",
        name: "userTicketCap",
        disabled: "",
        value: _ctx.postalEntryData.userTicketCap,
        readonly: ""
      }, null, 8, _hoisted_15),
      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "ticketsPurchasedByUser" }, [
        _createElementVNode("strong", null, "Tickets Purchased by User:")
      ], -1)),
      _createElementVNode("input", {
        id: "ticketsPurchasedByUser",
        name: "ticketsPurchasedByUser",
        disabled: "",
        value: _ctx.postalEntryData.ticketsPurchasedByUser,
        readonly: ""
      }, null, 8, _hoisted_16),
      _cache[14] || (_cache[14] = _createElementVNode("label", { for: "ticketsAvailableToUser" }, [
        _createElementVNode("strong", null, "Tickets Available to User:")
      ], -1)),
      _createElementVNode("input", {
        id: "ticketsAvailableToUser",
        name: "ticketsAvailableToUser",
        disabled: "",
        value: _ctx.postalEntryData.ticketsAvailableToUser,
        readonly: ""
      }, null, 8, _hoisted_17)
    ])
  ]))
}